import { useNavigate } from 'react-router-dom';

export const useNavigationHelpers = () => {
  const navigate = useNavigate();

  const goBack = (fallbackPath = '/') => {
    // Check if there is a previous page in the history stack
    // window.history.state.idx > 0 is specific to React Router's internal tracker
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return { goBack };
};